import { render, staticRenderFns } from "./WalkDetail.vue?vue&type=template&id=2dbe9556&scoped=true&"
import script from "./WalkDetail.vue?vue&type=script&lang=js&"
export * from "./WalkDetail.vue?vue&type=script&lang=js&"
import style0 from "./WalkDetail.vue?vue&type=style&index=0&id=2dbe9556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe9556",
  null
  
)

export default component.exports